import React from 'react';
import { Controller } from 'react-hook-form';
import CreatableSelect from 'react-select/creatable';
import VECIErrorMessage from './VECIErrorMessage';
import { toTitleCase } from '../../utils/textFormat';

const VECIProfilResponden = ({
  register,
  errors,
  watch,
  control,
  setValue,
}) => (
  <div className='card border-0 shadow-sm rounded-4 p-4 p-md-5'>
    <div className='d-flex align-items-center mb-4 border-bottom pb-3'>
      <div className='bg-primary bg-opacity-10 p-3 rounded-4 me-3'>
        <i className='bi bi-person-badge text-primary fs-3'></i>
      </div>
      <div>
        <h4 className='fw-bold mb-0'>Profil Direktur BUMDesa</h4>
        <p className='text-muted small mb-0'>Informasi dasar pengisi survey</p>
      </div>
    </div>
    <div className='row g-4'>
      <div className='col-md-8'>
        <label className='form-label fw-semibold'>Nama Responden</label>
        <input
          {...register('respondent.respondentName', {
            required: 'Nama responden wajib diisi',
            onBlur: (e) =>
              setValue(
                'respondent.respondentName',
                toTitleCase(e.target.value),
              ),
          })}
          className={`form-control border-2 ${errors?.respondent?.respondentName ? 'is-invalid border-danger' : ''}`}
        />
        <VECIErrorMessage error={errors?.respondent?.respondentName} />
      </div>
      <div className='col-md-4'>
        <label className='form-label fw-semibold'>Jenis Kelamin</label>
        <select
          {...register('respondent.gender', {
            required: 'Pilih jenis kelamin',
          })}
          className={`form-select border-2 ${errors?.respondent?.gender ? 'is-invalid border-danger' : ''}`}
        >
          <option value=''>Pilih...</option>
          <option value='Male'>Laki-laki</option>
          <option value='Female'>Perempuan</option>
        </select>
        <VECIErrorMessage error={errors?.respondent?.gender} />
      </div>
      <div className='col-md-4'>
        <label className='form-label fw-semibold'>Tanggal Lahir</label>
        <input
          {...register('respondent.dateOfBirth', {
            required: 'Tanggal lahir wajib diisi',
          })}
          type='date'
          className={`form-control border-2 ${errors?.respondent?.dateOfBirth ? 'is-invalid border-danger' : ''}`}
        />
        <VECIErrorMessage error={errors?.respondent?.dateOfBirth} />
      </div>
      <div className='col-md-2'>
        <label className='form-label fw-semibold'>Umur</label>
        <input
          {...register('respondent.age')}
          readOnly
          className='form-control bg-light border-2 text-center'
        />
      </div>
      <div className='col-md-6'>
        <label className='form-label fw-semibold'>Pendidikan Terakhir</label>
        <select
          {...register('respondent.lastEducation', {
            required: 'Pilih pendidikan terakhir',
          })}
          className={`form-select border-2 ${errors?.respondent?.lastEducation ? 'is-invalid border-danger' : ''}`}
        >
          <option value=''>Pilih Pendidikan...</option>
          <option value='SLTA'>SLTA / Sederajat</option>
          <option value='D1-D3'>D1-D3</option>
          <option value='S1'>S1 / Diploma IV</option>
          <option value='S2'>S2</option>
          <option value='S3'>S3</option>
        </select>
        <VECIErrorMessage error={errors?.respondent?.lastEducation} />
      </div>
      <div className='col-md-6'>
        <label className='form-label fw-semibold'>No. WhatsApp</label>
        <div className='small text-muted mb-2'>
          Gunakan awalan 62 (Contoh: 62812...)
        </div>
        <input
          {...register('respondent.phoneNumber', {
            required: 'Nomor WhatsApp wajib diisi',
            pattern: {
              value: /^628[0-9]{8,12}$/,
              message:
                'Format tidak valid. Harus diawali 628 dan berjumlah 11-15 digit',
            },
          })}
          className={`form-control border-2 ${errors?.respondent?.phoneNumber ? 'is-invalid border-danger' : ''}`}
          placeholder='Contoh: 628123456789'
        />
        <VECIErrorMessage error={errors?.respondent?.phoneNumber} />
      </div>
      <div className='col-md-6'>
        <label className='form-label fw-semibold'>Jabatan di BUMDes</label>
        <Controller
          name='respondent.positionAtBumdes'
          control={control}
          rules={{ required: 'Pilih atau isi jabatan responden' }}
          render={({ field }) => (
            <>
              <CreatableSelect
                {...field}
                isClearable
                placeholder='Pilih jabatan...'
                options={[
                  {
                    value: 'Direktur/CEO/Ketua BUMDesa',
                    label: 'Direktur/CEO/Ketua BUMDesa',
                  },
                ]}
                value={
                  field.value
                    ? { value: field.value, label: field.value }
                    : null
                }
                onChange={(val) =>
                  field.onChange(val ? toTitleCase(val.value) : '')
                }
                classNamePrefix='react-select'
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: '0.5rem',
                    borderColor: errors?.respondent?.positionAtBumdes
                      ? '#dc3545'
                      : '#dee2e6',
                    borderWidth: '2px',
                    padding: '2px',
                    fontSize: '1rem',
                    '&:hover': {
                      borderColor: errors?.respondent?.positionAtBumdes
                        ? '#dc3545'
                        : '#0d6efd',
                    },
                  }),
                }}
              />
              <VECIErrorMessage error={errors?.respondent?.positionAtBumdes} />
            </>
          )}
        />
      </div>
      <div className='col-12'>
        <label className='form-label fw-semibold'>
          Alamat Domisili (RT/RW, Jalan, No. Rumah)
        </label>
        <textarea
          {...register('respondent.residentialAddress', {
            required: 'Alamat domisili wajib diisi',
            onBlur: (e) =>
              setValue(
                'respondent.residentialAddress',
                toTitleCase(e.target.value),
              ),
          })}
          placeholder='Contoh: Jl. Raya Desa Makmur No. 45, RT 02/RW 04'
          className={`form-control border-2 rounded-4 ${errors?.respondent?.residentialAddress ? 'is-invalid border-danger' : ''}`}
          rows='3'
        ></textarea>
        <VECIErrorMessage error={errors?.respondent?.residentialAddress} />
      </div>
    </div>
  </div>
);

export default VECIProfilResponden;
